import React from "react";
import clsx from "clsx";
import Exterior360 from "./Exterior360";
import styles from "../SpinContainer.module.scss";
import { SpinnerType } from "../../../../../redux/slices/CarConfigSpinNavigationSlice";
import { useCarConfigSelector } from "../../../../../redux/store";

type Props = {
    settings?: { autoHeight?: boolean; showOnMobile?: boolean; bgColour?: string };
};

export const EXTERIOR_SPIN_ID = "or-exterior-spin-wrapper";

const Exterior360Wrapper = (props: Props): JSX.Element => {
    const { settings } = props;

    const exteriorSpinIsActive = useCarConfigSelector(
        (state) => state.carConfigSpinNavigation.activeSpin === SpinnerType.Car,
    );

    return (
        <figure
            className={clsx(exteriorSpinIsActive ? styles.active : styles.inactive, styles["spin-image-wrapper"])}
            id={EXTERIOR_SPIN_ID}
        >
            <div>
                <Exterior360
                    index={3}
                    imageOptions={{ bgColour: settings?.bgColour ?? "FFFFFF", width: 1000, height: 533, padding: 0 }}
                />
            </div>
        </figure>
    );
};

export default Exterior360Wrapper;
